<template>
<div class="swaychat-upload" v-if="getFiles.length">
  <div v-for="item in getFiles" class="swaychat-upload-file-list" v-if="item.upload < 100 && !item.cancelled" :class="{
    'swaychat-upload-error': item.error
    }">
    <div class="swaychat-upload-filename">{{ item.name }}</div>
    <div class="swaychat-upload-file-error">{{ item.error }}</div>
    <div class="swaychat-upload-progressbar-wrapper">
      <div class="swaychat-upload-progressbar">
        <div class="swaychat-upload-progressbar-value" :style="{
            'background-color': getPrimaryBg,
            'width': item.upload +'%'
            }"></div>
      </div>
    </div>
    <div class="swaychat-upload-file-size">{{ convertFilesize(item.size) }}</div>
    <div class="swaychat-upload-remove-file swaychat-button-close" @click="item.cancel"></div>
  </div>
</div>
</template>

<script>
import {
  mapGetters
} from 'vuex'

export default {
  computed: {
    ...mapGetters([
      'getLang',
      'getFiles',
      'getPrimaryBg'
    ])
  },
  methods: {
    convertFilesize(bytesize) {
      let size = bytesize * 0.001

      if (size >= 1000)
        return (size / 1000).toFixed(1) + ' MB'

      if (size.toFixed(1) <= 0)
        return '0 KB'

      return size.toFixed(1) + ' KB'
    }
  }
}
</script>
